import { Modal } from '@unified-checkout/design-system';

import type { IConfirmationModalProps } from '@app/dashboard/types/innerLayout/reach/modals/confirmation-modal';
import { MOBILE_BREAKPOINT } from '@app/dashboard/constants/break-points';
import { useScreenWidth } from '@app/dashboard/hooks/useScreenWidth';

import styles from './ConfirmationModal.module.scss';

export const ConfirmationModal = ({
  open,
  modalContent: { title, supportingText, modalState },
  primaryBtn: {
    text: primaryBtnText,
    color,
    onClick: onPrimaryClick,
    loading: loading,
    disabled: disabled,
  },
  secondaryBtn: {
    text: secondaryBtnText,
    onClick: handleCancel,
    color: secondaryBtnColor = 'secondary',
    disabled: secondaryBtnDisabled = false,
  },
  children,
  isModalStateContent = false,
  handleClose,
  hasCloseIcon = false,
}: IConfirmationModalProps) => {
  const screenWidth = useScreenWidth();
  const isMobile = screenWidth <= MOBILE_BREAKPOINT;

  return (
    <Modal
      wrapperClassName={styles['confirmation-modal']}
      isOverlayAboveModal
      isMobile={isMobile}
      closeOnClickOutside={false}
      state={modalState || 'danger'}
      open={open}
      title={title}
      supportingText={supportingText}
      hasCloseIcon={hasCloseIcon}
      onCloseHandler={handleClose}
      {...(isModalStateContent
        ? {}
        : {
            btnsProps: [
              {
                size: 'lg',
                color: color,
                variant: 'contained',
                text: primaryBtnText,
                onClickHandler: onPrimaryClick,
                loading: loading,
                disabled: disabled,
              },
              {
                size: 'lg',
                color: secondaryBtnColor,
                variant: 'outlined',
                text: secondaryBtnText,
                onClickHandler: handleCancel || handleClose,
                disabled: secondaryBtnDisabled,
              },
            ],
          })}
    >
      {children}
    </Modal>
  );
};
